import type { ButtonHTMLAttributes } from 'react';
import { Icon } from '@/ui/icons/Icon';
import { cx } from './cx';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  readonly icon?: string;
}

export function Button({
  variant = 'secondary',
  icon,
  type = 'button',
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button type={type} className={cx(styles.button, styles[variant], className)} {...rest}>
      {icon !== undefined && <Icon name={icon} size={18} />}
      {children}
    </button>
  );
}
